import { Paper, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { Box } from '@mui/system'
import AccesosDirectos from 'common/components/AccesosDirectos'
import MsgBienvenida from 'common/components/MsgBienvenida'
import useCurrentMenu from 'common/hooks/useCurrentMenu'
import { CustomThemeContext } from 'common/providers/CustomThemeProvider'
import Avisos from 'features/avisos/components/Avisos'
import WidgetsCalendario from 'features/calendario/components/WidgetsCalendario'
import WidgetsHojasGasto from 'features/hojasgasto/components/WidgetsHojasGasto'
import NewsList from 'features/noticias/components/NewsList'
import { selectPortal } from 'features/portal/portalSlice'
import VisorPreguntas from 'features/preguntas/pages/VisorPreguntas'
import { useRouteIsActive } from 'features/routing/libs/routeIsActive'
import { useContext } from 'react'
import { useSelector } from 'react-redux'

const Home = () => {
  const menu = useCurrentMenu()
  const { themeController } = useContext(CustomThemeContext)
  const portal = useSelector(selectPortal)
  const numberOfNews = menu?.currentMenu?.parametros?.NUM_NOTICIAS ?? 3
  const newsByRow = menu?.currentMenu?.parametros?.NOTICIAS_FILA ?? 3

  const calendarioIsActive = useRouteIsActive('/calendario', true)
  const hojasGastosIsActive = useRouteIsActive('/hojasgasto', true)

  return (
    <Box sx={{ pb: 0 }}>
      <Box>
        {themeController?.hide?.Home?.bienvenida ? (
          <></>
        ) : (
          <Paper
            className={themeController?.hide?.Home?.bienvenida_background ? '' : 'degradado'}
            sx={{
              display: 'flex',
              mb: 2,
              flexDirection: 'column',
              py: 5,
              px: { xs: 2, md: 5 },
              backgroundColor: themeController?.hide?.Home?.bienvenida_background
                ? 'transparent'
                : 'background.default',
            }}
          >
            <MsgBienvenida />
          </Paper>
        )}
        <AccesosDirectos sx={{ mt: 0, mb: 2 }} codigo="HOME" clean />
        <Avisos sx={{ mb: 2 }} mode="slider" />
        {!calendarioIsActive || themeController?.hide?.Home?.widgets_calendario ? (
          <></>
        ) : (
          <WidgetsCalendario sx={{ mb: 2 }} />
        )}
        {!hojasGastosIsActive || themeController?.hide?.Home?.widgets_hojas_gasto ? (
          <></>
        ) : (
          <WidgetsHojasGasto
            sxBox={{ width: '100%', justifyContent: 'center', alignItems: 'center', mb: 2 }}
            sxCardBox={{ flexDirection: 'row', gap: 2 }}
          />
        )}
        <Grid container spacing={2}>
          {themeController?.hide?.Home?.noticias ? (
            <></>
          ) : (
            <Grid
              size={
                themeController?.hide?.Home?.preguntas_frecuentes
                  ? { md: 12, xs: 12 }
                  : { md: 7, xs: 12 }
              }
            >
              <Paper className="content-paper" sx={{ p: 2 }}>
                <Typography variant="h4" className="bold" sx={{ mb: 3 }}>
                  Noticias
                </Typography>
                <NewsList
                  showFilter={false}
                  noPaginate={true}
                  pageSize={numberOfNews ?? 3}
                  rowCount={themeController?.hide?.Home?.preguntas_frecuentes ? newsByRow : 1}
                  allBanner={true}
                  showPaginateButton={true}
                />
              </Paper>
            </Grid>
          )}
          {themeController?.hide?.Home?.preguntas_frecuentes ? (
            <></>
          ) : (
            <Grid size={{ md: 5, xs: 12 }}>
              <Paper className="content-paper" sx={{ backgroundColor: 'background.warning' }}>
                <Typography variant="h4" className="bold" sx={{ color: 'warning.main', mb: 3 }}>
                  Preguntas Frecuentes
                </Typography>
                <VisorPreguntas />
              </Paper>
            </Grid>
          )}
        </Grid>
        {themeController?.hide?.Home?.imagen_fondo ||
        !portal?.portal?.imagen_fondo ||
        portal?.portal?.imagen_fondo === '' ? (
          <></>
        ) : (
          <Box
            component={'img'}
            src={`assets/images/${portal?.portal?.imagen_fondo}`}
            className="imagen_fondo"
            id="imagen_fondo"
            alt="Imagen de fondo"
            sx={{ width: '100%', mt: 2 }}
          />
        )}
      </Box>
    </Box>
  )
}

export default Home
